import { LangCode, LanguageCode } from "../models";

export interface AttributeInput {
  id?: number;
  attribute_key_translations: AttributeInfoInput[];
}

interface AttributeInfoInput {
    language: LanguageCode;
  name: string;
  // slug: string;
}

export interface AttributeValueInput {
    slug: string; ///chnged by rizwan441
  id?: number;
  attributeId?: number;
  // attribute_value_translations: AttributeValueInfoInput[];
}

interface AttributeValueInfoInput {
  language: LanguageCode;
  value?: string;
  additions?: any;
}